var $ece77a10c9739c65$exports = {};
$ece77a10c9739c65$exports = {
  "pending": `pendente`
};
export { $ece77a10c9739c65$exports as default };